import z from 'zod';
import type { CommentDto } from './comment.dto';
import type { NeedResourceInteractionDto, ResourceInteractionDto, ResourcingRequest } from './resourcing.dto';
import type { InteractionBaseDto } from './interactions/interaction-base.dto';
import type { UpsertUserNeedRequestDto } from './needs.dto';

export type VisitDto = {
  id: number;
  resourceInteraction: ResourceInteractionDto;
  needResourceInteraction: NeedResourceInteractionDto;
  subjectUserId: string;
  location: string;
  description: string;
  startTime: number;
  endTime: number;
  outcomeId: number;
  outcomeDetails: string;
  comments: CommentDto[];
  createdBy: string;
  addressId: number;
  note: string;
  insufficientNotes: boolean;
} & InteractionBaseDto<'visit'>;

export interface VisitCreationRequestDto {
  subjectUserId: string;
  location: string;
  description: string;
  startTime?: number;
  endTime?: number;
  outcomeId: number;
  outcomeDetails: string;
  scheduledEventId: number;
  addressId: number;
  note: string;
  resourceInteraction?: ResourcingRequest;
  needResourceInteraction?: ResourcingRequest;
  userNeedRequest?: UpsertUserNeedRequestDto;
}

export interface VisitUpdateRequestDto {
  visitId?: number;
  location?: string;
  description?: string;
  startTime?: number;
  endTime?: number;
  outcomeId?: number;
  outcomeDetails?: string;
  addressId?: number;
  note?: string;
  resourceInteraction?: ResourcingRequest;
  needResourceInteraction?: ResourcingRequest;
  userNeedRequest?: UpsertUserNeedRequestDto;
}

export interface VisitOutcomeDto {
  id: number;
  key: string;
  text: string;
  deprecatedAt: number;
  outcomeTypes: string[];
}

export const CreateVisitSchema = z.object({
  subjectUserId: z.string().optional(),
  addressId: z.coerce.number().optional(),
  location: z.string().optional().nullable(),
  date: z.string(),
  start: z.number(),
  duration: z.number(),
  outcomeId: z.number().optional(),
  note: z.string().optional(),
});

export type CreateVisitForm = z.infer<typeof CreateVisitSchema>;
